import moment from "moment";
export default function formAPIDoctorFavLabs({
  id,
  createddate,
  testname,


}) {
  return Object.freeze({
    id,
    createddate,
    testname,

  });
}